$(document).ready(function() {
    'use strict';

    $('body').on('click vclick keyup', '.video-trigger', function(e) {
        //e.preventDefault();

        // * Bail out if tabbed
        if (e.type === 'keyup') {
            var key = e.keyCode || e.which;
            if (key === 9) {
                return;
            }
        }

        var videoType = $(this).data('open');
        var videoID = parseYoutubeId($(this).data('youtube-id'));

        if ((videoType === 'youtube-video') && (videoID.length)) {
            var videoURL = 'https://www.youtube.com/embed' + videoID + '?autoplay=1&showinfo=0&controls=1&rel=0';
            $('#youtube-video').find('iframe').attr('src', videoURL);
        }
    });

    $('#youtube-video').on('closed.zf.reveal', function() {
        $('#youtube-video iframe').attr('src', 'https://www.youtube.com/embed/?autoplay=1&amp;showinfo=0&amp;controls=1&amp;rel=0');
    });
});


function parseYoutubeId(value) {
    if (value.includes("http://youtu.be") || value.includes("https://youtu.be")) {
        return value.split("youtu.be")[1];
    }
    else if (value.includes("www.youtube.com")) {
        if (value.includes("v=")) {
            vPos = value.search("v=") + 2;

            if (value.includes("&")) {
                ampPos = value.search("&");

                if (vPos < ampPos) {
                    return "/" + value.substr(vPos + 2, ampPos - vPos);
                }
            }
            else {
                return "/" + value.substr(vPos);
            }
        }
    }
    else {
        return "/" + value;
    }
}